module.exports = __webpack_public_path__ + "static/media/404.0c01eff1.png";